import { Crud, HttpClient, httpClient, QueryParameter } from 'lib/HttpClient';
import { IGetReviewsOptions } from './reviews';

class ReviewsApi extends Crud {
    constructor(client: HttpClient) {
        super(client, import.meta.env.API_SERVER_URL, 'reviews');
    }

    getReviews(options: IGetReviewsOptions) {
        const queryParameters: QueryParameter[] = [];
        Object.entries(options).forEach(([key, value]) => {
            if (value) {
                queryParameters.push({ key, value });
            }
        });
        return this.httpClient.get(`${this.api}/reviews`, { queryParameters });
    }
}

export const reviewsApi = new ReviewsApi(httpClient);
